import { stickyStackManager } from './stickyStackManager';

let stickyStackIdCounter = 0;
let containerV2MutationObserver;

window.addEventListener('DOMContentLoaded', () => {
  registerContainerV2Events();
  observeLateContainerV2Changes();
});

function registerContainerV2Events() {
  document.querySelectorAll('.sticky-top-container').forEach((container) => {
    registerStickyContainer(container);
  });

  document.querySelectorAll('.sticky-sm-top').forEach((container) => {
    addResponsiveStickyClasses(container, 'sm');
  });
  document.querySelectorAll('.sticky-md-top').forEach((container) => {
    addResponsiveStickyClasses(container, 'md');
  });
  document.querySelectorAll('.sticky-lg-top').forEach((container) => {
    addResponsiveStickyClasses(container, 'lg');
  });
  document.querySelectorAll('.sticky-xl-top').forEach((container) => {
    addResponsiveStickyClasses(container, 'xl');
  });
}

function registerStickyContainer(container) {
  const stickyStackId = container.dataset.stickyStackSource || `container-v2-${stickyStackIdCounter++}`;
  const parentContainer = container.parentElement;
  const stickyLayerTargets = [];
  container.dataset.stickyStackSource = stickyStackId;
  container.querySelectorAll('nav.microsite').forEach((micrositeNav) => {
    if (micrositeNav.closest('.sticky-top-container') !== container) {
      return;
    }
    stickyLayerTargets.push(micrositeNav);
  });
  stickyLayerTargets.push(parentContainer);
  parentContainer.classList.add('sticky-top');
  if (parentContainer.classList.contains('container-fluid')) {
    parentContainer.parentElement.classList.add('sticky-top');
    stickyLayerTargets.push(parentContainer.parentElement);
  } else {
    parentContainer.classList.add('sticky-top');
  }
  stickyStackManager.registerLayer(stickyStackId, stickyLayerTargets, parentContainer);
}

function observeLateContainerV2Changes() {
  if (containerV2MutationObserver) {
    return;
  }

  containerV2MutationObserver = new MutationObserver((mutationsList) => {
    const hasStickyMarkupChange = mutationsList.some((mutation) =>
      Array.from(mutation.addedNodes).some(
        (node) =>
          node.nodeType === Node.ELEMENT_NODE &&
          (node.matches('.sticky-top-container') ||
            node.querySelector('.sticky-top-container') ||
            (node.matches('nav.microsite') && node.closest('.sticky-top-container')) ||
            node.querySelector('nav.microsite'))
      )
    );

    if (hasStickyMarkupChange) {
      registerContainerV2Events();
    }
  });

  containerV2MutationObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

function addResponsiveStickyClasses(container, breakpoint) {
  const parentContainer = container.parentElement;
  parentContainer.classList.add('sticky-' + breakpoint + '-top');
  if (parentContainer.classList.contains('container-fluid')) {
    parentContainer.parentElement.classList.add('sticky-' + breakpoint + '-top');
  } else {
    parentContainer.classList.add('sticky-' + breakpoint + '-top');
  }
}
